document.addEventListener('DOMContentLoaded', function () {
  console.log('DOM cargado - inicializando carrito');
  initCartDrawer();
  listenForAddToCartDelegated();
  listenForAddToCartButtons();
  listenForWishlistButtons(); // ✅ NUEVO

  const fromCartAdd = sessionStorage.getItem('cartOpened') === 'true';
  const lastPage = sessionStorage.getItem('cartPageUrl');
  const currentPage = window.location.pathname + window.location.search;

  if (fromCartAdd && lastPage === currentPage) {
    sessionStorage.removeItem('cartOpened');
    sessionStorage.removeItem('cartPageUrl');
    setTimeout(function () {
      refreshCart();
    }, 500);
  }
});

function initCartDrawer() {
  const cartToggle = document.querySelectorAll('.js-cart-trigger, [data-cart-toggle], .header-cart, .thb-secondary-cart, #cart-drawer-toggle');
  const cartDrawer = document.getElementById('pinnacle-cart-drawer');
  const cartOverlay = document.getElementById('pinnacle-cart-drawer-overlay');
  const closeCart = document.getElementById('close-cart');

  if (!cartDrawer) return;

  function openCart(e) {
    if (e) e.preventDefault();
    cartDrawer.classList.add('active');
    cartOverlay.classList.add('active');
    document.body.classList.add('no-scroll');
  }

  function closeCartDrawer() {
    cartDrawer.classList.remove('active');
    cartOverlay.classList.remove('active');
    document.body.classList.remove('no-scroll');
  }

  cartToggle.forEach(toggle => {
    if (toggle) toggle.addEventListener('click', openCart);
  });

  if (closeCart) closeCart.addEventListener('click', closeCartDrawer);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  initQuantityButtons();
  initRemoveButtons();

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cartDrawer.classList.contains('active')) {
      closeCartDrawer();
    }
  });
}

function initQuantityButtons() {
  document.querySelectorAll('.pinnacle-quantity-button').forEach(button => {
    const newButton = button.cloneNode(true);
    button.parentNode.replaceChild(newButton, button);
    button = newButton;

    button.addEventListener('click', function (e) {
      e.preventDefault();
      if (this.disabled) return;
      
      this.disabled = true;
      const id = this.getAttribute('data-id');
      const input = document.querySelector(`input[data-id="${id}"]`);
      let value = parseInt(input.value);

      if (this.classList.contains('decrease')) {
        value = Math.max(0, value - 1);
      } else if (this.classList.contains('increase')) {
        value += 1;
      }

      input.value = value;
      this.classList.add('clicked');

      if (value === 0) {
        const cartItem = this.closest('.pinnacle-cart-item');
        if (cartItem) {
          cartItem.style.opacity = "0.5";
          setTimeout(() => {
            cartItem.style.height = "0";
            cartItem.style.padding = "0";
            cartItem.style.margin = "0";
            cartItem.style.overflow = "hidden";
          }, 300);
        }
      }

      updateCartItem(id, value);

      setTimeout(() => {
        this.disabled = false;
        this.classList.remove('clicked');
      }, 500);
    });
  });

  document.querySelectorAll('.pinnacle-cart-item-quantity input').forEach(input => {
    let debounceTimeout;
    
    input.addEventListener('change', function (e) {
      e.preventDefault();
      const id = this.getAttribute('data-id');
      let value = parseInt(this.value);

      if (isNaN(value) || value < 0) {
        value = 1;
        this.value = 1;
      }

      if (value === 0) {
        const cartItem = input.closest('.pinnacle-cart-item');
        if (cartItem) {
          cartItem.style.opacity = "0.5";
        }
      }

      clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(() => {
        updateCartItem(id, value);
      }, 300);
    });
  });
}

function initRemoveButtons() {
  document.querySelectorAll('.pinnacle-remove-item').forEach(button => {
    button.addEventListener('click', function () {
      const id = this.getAttribute('data-id');
      button.disabled = true;
      const cartItem = button.closest('.pinnacle-cart-item');
      if (cartItem) {
        cartItem.style.opacity = "0.5";
        setTimeout(() => {
          cartItem.style.height = "0";
          cartItem.style.padding = "0";
          cartItem.style.margin = "0";
          cartItem.style.overflow = "hidden";
        }, 300);
      }
      updateCartItem(id, 0);
    });
  });
}

let isUpdating = false;
let pendingUpdates = [];
let lastUpdateTime = 0;
const DEBOUNCE_TIME = 300;

function updateCartItem(id, quantity) {
  console.log(`Actualizando item ${id} a cantidad ${quantity}`);
  
  const now = Date.now();
  if (now - lastUpdateTime < DEBOUNCE_TIME) {
    console.log('Ignorando actualización debido al debounce');
    return;
  }
  lastUpdateTime = now;

  if (isUpdating) {
    console.log('Ya hay una actualización en curso, encolando la solicitud...');
    pendingUpdates = [{ id, quantity }];
    return;
  }

  isUpdating = true;
  document.body.classList.add('cart-updating');

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ id: id, quantity: quantity })
  })
    .then(response => {
      if (!response.ok) throw new Error('Error en el servidor: ' + response.status);
      return response.json();
    })
    .then(cart => {
      console.log('Carrito actualizado:', cart);
      refreshCart();
      isUpdating = false;

      if (pendingUpdates.length > 0) {
        const nextUpdate = pendingUpdates.shift();
        setTimeout(() => {
          updateCartItem(nextUpdate.id, nextUpdate.quantity);
        }, DEBOUNCE_TIME);
      }
    })
    .catch(error => {
      console.error('Error al actualizar:', error);
      isUpdating = false;
      refreshCart();
    })
    .finally(() => {
      document.body.classList.remove('cart-updating');
    });
}

function refreshCart() {
  console.log('Refrescando carrito completo...');
  fetch('/?section_id=cart-drawer')
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('#pinnacle-cart-drawer');
      const currentDrawer = document.querySelector('#pinnacle-cart-drawer');

      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
      }

      initQuantityButtons();
      initRemoveButtons();
      initCartDrawer();
      initRecommendedCarousel();
      currentDrawer.classList.add('active');
      document.getElementById('pinnacle-cart-drawer-overlay').classList.add('active');
      document.body.classList.add('no-scroll');
    })
    .catch(error => console.error('Error al refrescar el carrito:', error));
}

function listenForAddToCartDelegated() {
  document.body.addEventListener('submit', function (e) {
    if (e.target.matches('form[action^="/cart/add"]')) {
      e.preventDefault();
      const form = e.target;
      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(response => response.json())
        .then(data => {
          console.log('Producto agregado (form):', data);
          sessionStorage.setItem('cartOpened', 'true');
          refreshCart();
        })
        .catch(error => console.error('Error al agregar producto:', error));
    }
  });
}

function listenForAddToCartButtons() {
  let isAddingToCart = false;
  
  document.body.addEventListener('click', function (e) {
    const button = e.target.closest('[data-product-id]');
    if (button && button.matches('.product-card--add-to-cart-button') && !isAddingToCart) {
      e.preventDefault();
      const variantId = button.getAttribute('data-product-id');
      if (!variantId) return;

      isAddingToCart = true;
      button.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(res => res.json())
        .then(data => {
          console.log('Producto agregado (botón suelto):', data);
          const btnText = button.innerText.trim().toLowerCase();
          if (btnText.includes('agregar')) {
            sessionStorage.setItem('cartOpened', 'true');
            refreshCart();
            updateCartItem(variantId, 1)
          }
        })
        .catch(err => console.error('Error al agregar:', err))
        .finally(() => {
          isAddingToCart = false;
          button.disabled = false;
        });
    }
  });
}

// ✅ NUEVO: Wishlist
function listenForWishlistButtons() {
  let isAddingFromWishlist = false;

  document.body.addEventListener('click', function (e) {
    const button = e.target.closest('.wishlist-cart.wishlist-move-cart');
    if (button && !isAddingFromWishlist) {
      e.preventDefault();

      const variantId = button.getAttribute('data-variant_id');
      if (!variantId) {
        console.warn('El botón de wishlist no tiene data-variant_id');
        return;
      }

      isAddingFromWishlist = true;
      button.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(res => res.json())
        .then(data => {
          console.log('✅ Producto agregado desde wishlist:', data);
          sessionStorage.setItem('cartOpened', 'true');
          refreshCart();
        })
        .catch(err => console.error('❌ Error al agregar desde wishlist:', err))
        .finally(() => {
          isAddingFromWishlist = false;
          button.disabled = false;
        });
    }
  });
}

function initRecommendedCarousel() {
  const drawer = document.querySelector('#pinnacle-cart-drawer');
  if (!drawer) return;

  const carousel = drawer.querySelector('.recommended-carousel');
  const wrapper = drawer.querySelector('.recommended-carousel-wrapper');
  let prevBtn = drawer.querySelector('.carousel-prev');
  let nextBtn = drawer.querySelector('.carousel-next');

  if (!carousel || !prevBtn || !nextBtn) return;

  try {
    const prevClone = prevBtn.cloneNode(true);
    prevBtn.parentNode.replaceChild(prevClone, prevBtn);
    const nextClone = nextBtn.cloneNode(true);
    nextBtn.parentNode.replaceChild(nextClone, nextBtn);
  } catch (err) {
    console.warn('Carousel: no se pudieron clonar botones', err);
  }

  prevBtn = drawer.querySelector('.carousel-prev');
  nextBtn = drawer.querySelector('.carousel-next');

  if (carousel._recommendedCarouselObserver) {
    try { carousel._recommendedCarouselObserver.disconnect(); } catch(e) {}
    delete carousel._recommendedCarouselObserver;
  }
  const scrollContainer = wrapper || carousel;
  if (carousel._recommendedCarouselOnScroll) {
    try { scrollContainer.removeEventListener('scroll', carousel._recommendedCarouselOnScroll); } catch(e) {}
    delete carousel._recommendedCarouselOnScroll;
  }

  let itemWidth = 135;
  let gap = 10;
  let step = (itemWidth + gap) * 3;
  let maxScroll = 0;

  const recalc = () => {
    const first = carousel.querySelector('.carousel-item');
    if (first) itemWidth = Math.round(first.getBoundingClientRect().width);

    const style = window.getComputedStyle(carousel);
    gap = parseFloat(style.gap);
    if (isNaN(gap)) gap = parseFloat(style.columnGap) || 10;

    step = (itemWidth + gap) * 3;
    maxScroll = Math.max(0, scrollContainer.scrollWidth - scrollContainer.clientWidth);
  };

  recalc();

  const useScroll = scrollContainer.scrollWidth > scrollContainer.clientWidth;

  let scrollAmount = useScroll ? scrollContainer.scrollLeft : 0;
  let transformAmount = 0;

  const onScroll = () => {
    if (useScroll) scrollAmount = scrollContainer.scrollLeft;
  };
  scrollContainer.addEventListener('scroll', onScroll, { passive: true });
  carousel._recommendedCarouselOnScroll = onScroll;

  const onPrev = () => {
    recalc();
    if (useScroll) {
      scrollAmount = Math.max(0, scrollAmount - step);
      scrollContainer.scrollTo({ left: scrollAmount, behavior: 'smooth' });
    } else {
      transformAmount = Math.max(0, transformAmount - step);
      carousel.style.transform = `translateX(-${transformAmount}px)`;
    }
  };

  const onNext = () => {
    recalc();
    if (useScroll) {
      const limit = Math.max(0, scrollContainer.scrollWidth - scrollContainer.clientWidth);
      scrollAmount = Math.min(limit, scrollAmount + step);
      scrollContainer.scrollTo({ left: scrollAmount, behavior: 'smooth' });
    } else {
      const visible = (wrapper ? wrapper.clientWidth : carousel.clientWidth);
      const limit = Math.max(0, carousel.scrollWidth - visible);
      transformAmount = Math.min(limit, transformAmount + step);
      carousel.style.transform = `translateX(-${transformAmount}px)`;
    }
  };

  prevBtn.addEventListener('click', onPrev);
  nextBtn.addEventListener('click', onNext);

  const ro = new ResizeObserver(() => {
    recalc();
    if (useScroll) {
      scrollAmount = Math.min(scrollAmount, Math.max(0, scrollContainer.scrollWidth - scrollContainer.clientWidth));
      scrollContainer.scrollTo({ left: scrollAmount });
    } else {
      transformAmount = Math.min(transformAmount, Math.max(0, carousel.scrollWidth - (wrapper ? wrapper.clientWidth : carousel.clientWidth)));
      carousel.style.transform = `translateX(-${transformAmount}px)`;
    }
  });
  ro.observe(carousel);
  if (scrollContainer !== carousel) ro.observe(scrollContainer);
  carousel._recommendedCarouselObserver = ro;

  const imgs = carousel.querySelectorAll('img');
  let imgsPending = imgs.length;
  if (imgsPending === 0) {
    recalc();
  } else {
    imgs.forEach(img => {
      if (img.complete) {
        imgsPending--;
      } else {
        img.addEventListener('load', () => {
          imgsPending--;
          if (imgsPending === 0) recalc();
        }, { once: true });
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", initRecommendedCarousel);
